import { render, staticRenderFns } from "./export-footer.vue?vue&type=template&id=30f759d0&scoped=true&"
import script from "./export-footer.vue?vue&type=script&lang=js&"
export * from "./export-footer.vue?vue&type=script&lang=js&"
import style0 from "./export-footer.vue?vue&type=style&index=0&id=30f759d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f759d0",
  null
  
)

export default component.exports